import ReactECharts from "echarts-for-react";

interface LineChartProps {
  data: Array<{ mois: string; total: number }>;
  color?: string;
  height?: number;
}

function formatMois(mois: string): string {
  const [year, month] = mois.split("-");
  const date = new Date(Number(year), Number(month) - 1, 1);
  return date.toLocaleDateString("fr-FR", { month: "short", year: "2-digit" });
}

export function LineChart({ data, color = "#0B6B53", height = 280 }: LineChartProps) {
  const labels = data.map((d) => formatMois(d.mois));
  const values = data.map((d) => d.total);
  const maxVal = Math.max(...values, 1);
  const minVal = Math.min(...values, 0);
  const pad = (maxVal - minVal) * 0.2 || 1;

  const option = {
    tooltip: {
      trigger: "axis",
      backgroundColor: "#333132",
      borderColor: color,
      borderWidth: 1,
      textStyle: { color: "#fff", fontSize: 13 },
      formatter: (params: { name?: string; value?: number }[]) => {
        const p = params[0];
        return `${p?.name ?? ""}<br/><span style="font-weight:600">${Number(p?.value ?? 0).toLocaleString("fr-FR")}</span> consultations`;
      },
      padding: [10, 14],
      borderRadius: 8,
    },
    grid: { left: 50, right: 20, top: 16, bottom: 36 },
    xAxis: {
      type: "category",
      data: labels,
      axisLabel: { color: "#9CA3AF", fontSize: 11 },
      axisLine: { show: false },
      axisTick: { show: false },
      boundaryGap: false,
    },
    yAxis: {
      type: "value",
      min: Math.max(0, minVal - pad),
      max: maxVal + pad,
      axisLabel: { color: "#9CA3AF", fontSize: 11 },
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { lineStyle: { color: "#E5E7EB", type: "dashed", opacity: 0.6 } },
    },
    series: [
      {
        type: "line",
        data: values,
        smooth: true,
        symbol: "circle",
        symbolSize: 7,
        lineStyle: { color, width: 3 },
        itemStyle: { color, borderColor: "#fff", borderWidth: 2 },
        areaStyle: {
          color: {
            type: "linear",
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: `${color}33` },
              { offset: 1, color: `${color}08` },
            ],
          },
        },
      },
    ],
    animation: true,
    animationDuration: 800,
  };

  return (
    <ReactECharts option={option} style={{ width: "100%", height }} notMerge />
  );
}
